import DestinationPage from "@/components/DestinationPage";
const related = [
  { name: "Egipt", slug: "egipt", image: "https://images.unsplash.com/photo-1705628080778-f86b2f90a114?w=600&q=80" },
  { name: "Grecia", slug: "grecia", image: "https://images.unsplash.com/photo-1506242592132-b7476b527d50?w=600&q=80" },
  { name: "Muntenegru", slug: "muntenegru", image: "https://images.unsplash.com/photo-1689517686262-628708bbc5d7?w=600&q=80" },
];
export default function TurciaPage() {
  return (
    <DestinationPage
      name="Turcia" nameRo="Turcia" slug="turcia" flag="🇹🇷"
      heroImage="https://images.unsplash.com/photo-1774850691859-0e339f94bebb?w=1920&q=80"
      metaTitle="Vacanță în Turcia din Chișinău | Oferte Antalya, Side, Alanya – Premium Style Travel"
      metaDescription="Pachete turistice Turcia din Chișinău. Antalya, Side, Alanya, Bodrum – All Inclusive. Zbor + hotel + transfer inclus. Oferte 2025-2026. Sună +373 60609292."
      tagline="Riviera Turcă – plaje superbe, hoteluri magnifice și servicii All Inclusive de excepție din Chișinău."
      description="Turcia este destinația preferată a milioane de turiști din Moldova și România. Antalya, Side, Alanya, Kemer și Bodrum oferă unele dintre cele mai bune hoteluri all inclusive din lume, cu plaje amenajate, piscine uriașe și animație non-stop. Istanbul, capitala culturală, fascinează prin Hagia Sofia, Bazarul Mare și Palatul Topkapi. Cappadocia uimește cu peisaje lunare și zboruri cu balonul. Turcia oferă raport calitate-preț excelent pentru toate bugetele."
      highlights={[
        "Antalya – capitala turismului de litoral cu plaje premium",
        "Side – ruine antice la malul mării",
        "Alanya – cetatea medievală și peștera Dim",
        "Istanbul – Hagia Sofia, Bazarul Mare, Bosfor",
        "Cappadocia – zboruri cu balonul deasupra coșurilor de zână",
        "Bodrum – cel mai exclusivist resort turcesc",
        "Pamukkale – cascadele de travertin alb",
        "Hoteluri Ultra All Inclusive 5★ la prețuri accesibile",
      ]}
      included={[
        "✈️ Zbor charter dus-întors din Chișinău",
        "🏨 Cazare hotel 4★ / 5★ All Inclusive sau Ultra All",
        "🚌 Transfer aeroport – hotel – aeroport",
        "🛡️ Asigurare medicală de călătorie",
        "📋 Toate taxele incluse",
      ]}
      faqs={[
        { q: "Cât durează zborul Chișinău – Antalya?", a: "Aproximativ 2h30 – 3 ore cu zbor charter direct din Chișinău." },
        { q: "Este nevoie de viză pentru Turcia?", a: "Nu, cetățenii moldoveni nu au nevoie de viză pentru Turcia pentru sejururi de până la 30 de zile." },
        { q: "Care este diferența dintre All Inclusive și Ultra All Inclusive?", a: "Ultra All Inclusive include și băuturi premium (importate), mai multe restaurante à la carte, minibar în cameră și activități suplimentare." },
        { q: "Când este sezonul în Turcia?", a: "Sezonul principal este mai–octombrie. Iulie–august este cel mai aglomerat. Mai și septembrie sunt ideale pentru prețuri mai bune și temperaturi plăcute." },
        { q: "Ce resort este recomandat pentru familii cu copii?", a: "Side, Belek și Kemer au cele mai bune hoteluri cu facilități pentru copii – parcuri acvatice, cluburi pentru copii și plaje liniștite." },
      ]}
      relatedDestinations={related}
    />
  );
}
